const workDetailList = {
  sisda: {
    title: 'Eportal Sisda Provinsi Sumatera Utara',
    jobType: 'Design and Developed',
    mainImg: 'sisda.png',
    altMainImg: 'Eportal Sisda Provinsi Sumatera Utara',
    website: 'http://sisda.sumutprov.go.id/',
    github: '',
    about: [
      'Website dari SISDA Provinsi Sumatera Utara dimana saya mengembangkan dengan tim IT Bappeda Pemprov Sumut.',
      'Disini saya juga membantu sebagian pengembangan website lain "Aplikasi E-Kinerja Irigasi".'
    ],
    frontEndTech: 'HTML • CSS • JS • Bootstrap •jQuery ',
    backEndTech: 'PHP • Codeigniter • Mysql',
    otherTech: '',
    features: ['Eportal.', 'Responsive.']
  },
  iiw: {
    title: 'PT. Ikhwanul Ikhlas Wisata',
    jobType: 'Design and Developed',
    mainImg: 'iiw.png',
    altMainImg: 'Plinth 2017 Representational images',
    website: 'https://ikhwanulikhlaswisata.com/',
    github: '',
    about: [
      'PT. Ikhwanul Ikhlas Wisata adalah salah satu perusahaan perjalanan ibadah umroh di kota medan.Untuk mengetahui info lebih detail anda dapat berkunjung ke website mereka',
      'Saya membuat website company profile dan sistem umroh untuk PT.Ikhwanul Ikhlas Wisata'
    ],
    frontEndTech: 'HTML • CSS • JS • Bootstrap •jQuery',
    backEndTech: 'PHP • Mysql',
    otherTech: '',
    features: [
      'Penjualan Kwitansi',
      'Sms Notifikasi',
      'Pendaftaran jamaah umroh',
      'Pendaftaraan perwakilan dan PSC',
      'Perhitungan omset',
      'Pengelolaan data jamaah',
      'Dll'
    ]
  },
  bpr: {
    title: 'BPR Intidana',
    jobType: 'Designed and Developed',
    mainImg: 'bpr.png',
    altMainImg: 'BPR Intidana',
    website: 'http://bprintidana.co.id/',
    github: '',
    about: [
      'Saya membuat web BPR Intidana dengan menggunakan wordpress yang sedikit dimodifikasi untuk memenuhi kebutuhan mereka'
    ],
    frontEndTech: '',
    backEndTech: '',
    otherTech: 'Wordpress',
    features: ['Loan Calculator', 'E-Aplikasi', 'Branch Locator']
  },
  doding: {
    title: 'Doding Haleluya',
    jobType: 'Design and Developed',
    mainImg: 'doding.png',
    altMainImg: 'Doding Haleluya',
    website:
      'https://play.google.com/store/apps/details?id=com.tua.bona.dodinghaleluya',
    github: '',
    about: ['Ini adalah versi digital dari buku Doding Simalungun'],
    frontEndTech: '',
    backEndTech: 'Java • SQLite ',
    otherTech: 'Android Studio',
    features: ['Kategori Lagu', 'Pencarian dengan No dan Judul']
  }
};

export default workDetailList;



// WEBPACK FOOTER //
// ./src/components/data/workDetails.js